import { tsrClient } from '@/libs/ts-rest/ts-client';
import { createListProductSuggestionsQueryOptions } from '@/modules/products/react-query';

export const useListProductSuggestionsQuery = (search: string) => {
	const { listProductSuggestions } = tsrClient.web.products;
	const queryOptions = createListProductSuggestionsQueryOptions(search);
	const productSuggestionsQueryResult = listProductSuggestions.useQuery(queryOptions);

	return productSuggestionsQueryResult;
};